export default __webpack_public_path__ + "static/061_0504_amalgam_naxos-b203182340c7ece0bbd6bfa9929a0800.webp";